// extracted by mini-css-extract-plugin
module.exports = {"root":"Details_root__3pKN5","btn":"Details_btn__Mg5V_","text":"Details_text__1ukfN"};